
import React, { useContext, useEffect, useState} from 'react'
import { Input, Select,  DatePicker, TreeSelect, Form, InputNumber, Checkbox } from 'antd'
import { StateContext } from '../../../state';
import './index.less'
import moment from 'moment';
import http from '../../../../../utils/server'
import Draggable from 'react-draggable';
import sha1 from '../../../../../utils/sha1';
import { Mode } from '../../../../../App';
import {DeviceContext} from './index'
var changeDev = false;

const devTypeorder =[
    {code:201,oId:1},
    {code:212,oId:2},
    {code:209,oId:3},
    {code:203,oId:4},
    {code:208,oId:5},
    {code:205,oId:6},
    {code:210,oId:7},
    {code:211,oId:8},
    {code:206,oId:9},
    {code:207,oId:10},
    {code:202,oId:11},
    {code:204,oId:12},
];

async function  getSimByIccid(iccid,simToken) {
    let r ={
        iccid_expire:'2000-01-01',
        sim:'',
        status: '未找到',
        islock: false
    }

    let method = 'fc.function.card.info';
    let appKey = 'RL7i4T0Q9024bI7Z';
    let t = Math.floor(new Date().getTime()/1000)
    let sign = callSign(appKey,method,iccid,t);
    
    const results = await Promise.allSettled([
        (async () => {
            const res = await fetch(`http://hebeijiuchen.com/sim/card/all/query.do?queryString=${iccid}`, { //物联网卡查询 接口请求地址
                method: 'get',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `${simToken}`
                })
            })
            return res.json(); // 直接 return，等价于 .then() 的效果
        })(),
        (async () => {
            const res = await fetch(`https://api.quectel.com/openapi/router`,{
                method:'post',
                body:`appKey=${appKey}&iccid=${iccid}&method=${method}&sign=${sign}&t=${t}`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
            return res.json(); // 直接 return，等价于 .then() 的效果
        })(),
        // (async () => {
        //     const res = await http.get(`/v1/devicesiminfo?numbers=${iccid}`, {})
        //     return res; // 直接 return，等价于 .then() 的效果
        // })(),
    ])

    const validData = results
    .map(res => res.status === 'fulfilled' ? res.value : null)
    if(validData.length>0){
        let res = validData [0];
        if(res&&res.list&&res.list.length>0){
            r.iccid_expire =res.list[0].expireTime!==''?res.list[0].expireTime:'2000-01-01';
            r.sim =''+ res.list[0].mobile;
            r.status = '';
            r.islock = false
            r.id = 1
            let date1 = new Date(res.list[0].expireTime).getTime();
            let date2 = new Date().getTime();
            if( date2<date1){
                r.state = 0
            }else{
                let days = Math.floor((date2 -date1 )/(24*60*60*1000));
                if(days<20){
                    r.state = 1;
                }else{
                    r.state = 2;
                }
            }
        }
        res = validData [1];
        if(res&&res.resultCode===0){
            r.iccid_expire =res.expiryDate!==''?res.expiryDate:'2000-01-01';
            r.sim = res.msisdn;
            r.status = '';
            r.id = 2
            r.islock = res.islock===1?true:false;
            if(res.expiryDate!=""){
                let date1 = new Date(res.expiryDate).getTime();
                let date2 = new Date().getTime();
                if( date2<date1){
                    r.state = 0
                }else{
                    r.state = 1
                }
            }
        }
        res = validData [2];
        if(res&&res.code===200&&res.data.length>0){
            r.iccid_expire =res.data[0].expiretime!==''?res.data[0].expiretime.slice(0,10) :'2000-01-01';
            r.sim = res.data[0].msisdn;
            r.iccid = res.data[0].iccid
            r.status = '';
            r.islock = false
            r.state = res.data[0].state===3?1:res.data[0].state>3?2:0
        }
    }else{
        (async () => {
            await http.get(`/v1/devicesiminfo?numbers=${iccid}`, {}).then(res=>{
                if(res.code===200&&res.data.length>0){
                    r.iccid_expire =res.data[0].expiretime!==''?res.data[0].expiretime.slice(0,10) :'2000-01-01';
                    r.sim = res.data[0].msisdn;
                    r.iccid = res.data[0].iccid
                    r.status = '';
                    r.islock = false
                    r.id = 3
                    r.state = res.data[0].state===3?1:res.data[0].state>3?2:0
                }
            })
        })()
    }
    return r
}
async function  getSimBySim(sim,simToken) {
    let r ={
        iccid_expire:'2000-01-01',
        sim:'',
        status: '未找到',
        islock: false
    }
    let method = 'fc.function.card.info';
    let appKey = 'RL7i4T0Q9024bI7Z';
    let msisdn = sim;
    let t = Math.floor(new Date().getTime()/1000)
    let sign = callSign(appKey,method,msisdn,t);
    
    const results = await Promise.allSettled([
        (async () => {
            const res = await fetch(`http://hebeijiuchen.com/sim/card/all/query.do?queryString=${sim}`, { //物联网卡查询 接口请求地址
                method: 'get',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `${simToken}`
                })
            })
            return res.json(); // 直接 return，等价于 .then() 的效果
        })(),
        (async () => {
            const res = await fetch(`https://api.quectel.com/openapi/router`,{
                method:'post',
                body:`appKey=${appKey}&method=${method}&msisdn=${msisdn}&sign=${sign}&t=${t}`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
            return res.json(); // 直接 return，等价于 .then() 的效果
        })(),
        // (async () => {
        //     const res = await http.get(`/v1/devicesiminfo?numbers=${sim}`, {})
        //     return res; // 直接 return，等价于 .then() 的效果
        // })(),
    ])

    const validData = results
    .map(res => res.status === 'fulfilled' ? res.value : null)
    if(validData.length>0){
        let res = validData [0];
        if(res&&res.list&&res.list.length>0){
            r.iccid_expire =res.list[0].expireTime!==''?res.list[0].expireTime:'2000-01-01';
            r.sim =''+ res.list[0].mobile;
            r.iccid = res.list[0].iccid
            r.status = '';
            r.id = 1
            r.islock = false
            let date1 = new Date(res.list[0].expireTime).getTime();
            let date2 = new Date().getTime();
            if( date2<date1){
                r.state = 0
            }else{
                let days = Math.floor((date2 -date1 )/(24*60*60*1000));
                if(days<20){
                    r.state = 1;
                }else{
                    r.state = 2;
                }
            }
        }
        res = validData [1];
        if(res&&res.resultCode===0){
            r.iccid_expire =res.expiryDate!==''?res.expiryDate:'2000-01-01';
            r.sim = res.msisdn;
            r.iccid = res.iccid
            r.status = '';
            r.id = 2
            r.islock = res.islock===1?true:false;
            if(res.expiryDate!=""){
                let date1 = new Date(res.expiryDate).getTime();
                let date2 = new Date().getTime();
                if( date2<date1){
                    r.state = 0
                }else{
                    r.state = 1
                }
            }
        }
        res = validData [2];
        // if(res&&res.code===200&&res.data.length>0){
        //     r.iccid_expire =res.data[0].expiretime!==''?res.data[0].expiretime.slice(0,10) :'2000-01-01';
        //     r.sim = res.data[0].msisdn;
        //     r.iccid = res.data[0].iccid
        //     r.status = '';
        //     r.islock = false
        //     r.state = res.data[0].state===3?1:res.data[0].state>3?2:0
        // }
    }else{
        (async () => {
            await http.get(`/v1/devicesiminfo?numbers=${sim}`, {}).then(res=>{
                if(res.code===200&&res.data.length>0){
                    r.iccid_expire =res.data[0].expiretime!==''?res.data[0].expiretime.slice(0,10) :'2000-01-01';
                    r.sim = res.data[0].msisdn;
                    r.iccid = res.data[0].iccid
                    r.status = '';
                    r.islock = false
                    r.id = 3
                    r.state = res.data[0].state===3?1:res.data[0].state>3?2:0
                }
            })
        })()
        
    }
    return r
}

function callSign (appKey,method,s,t){
    let Secret = 'RA9026m2';
    let concat =`${Secret}appKey${appKey}`;
    if(s.length===13){
        let msisdn = s;
        concat +=`method${method}msisdn${msisdn}t${t}${Secret}`;
    }else{
        let iccid = s;
        concat +=`iccid${iccid}method${method}t${t}${Secret}`
    }
    let r = sha1.sha1(concat);
    return r
}
function DeviceNew( props) {
    const { actDevice, dispatchDevice, form, onfinish } = useContext(DeviceContext)
    const { state, dispatch } = useContext(StateContext)
    const [lockMName, setLockMName] = useState(false)
    const [lockNodeNum, setLockNodeNum] = useState(false)
    const [master, setMaster] = useState(0)
    const [nodeNum, setNodeNum] = useState(1)
    const [disOptions, setDisOptions] = useState([]);
    const [defExpend,setDefExpend]=useState([]);
    const [simToken,setSimToken] = useState('')
    const [simStatus,setSimStatus] = useState('')
    const [devTypeOption, setDevTypeOption] = useState([])
    const [isShowUser, setIsShowUser] = useState(false)
    const formRef = React.createRef();

    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 4 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 20 },
        },
    };
    useEffect(() => {
        setIsShowUser(props?.isShowUser)
        let devTypeOption = []
        state.devicetype.map(m=>{
            let temp = devTypeorder.filter(x=>x.code===m.code);
            m.oId =(temp&&temp.length>0)?temp[0].oId:m.code
            devTypeOption.push(m)
        })
        devTypeOption.sort((a,b)=>a.oId-b.oId)
        setDevTypeOption(devTypeOption)
        var p = state.systemuser.tree[0];
        let arrDis = new Array();
        Mode === 'soc' && state.district.filter(x => { return x.user === state.systemuser.tree[0].value }).map(item => arrDis.push(item));
        setDisOptions(Mode !== 'soc' ? state.district : arrDis);
        const d_d = state.district.filter(x => { return x.id === actDevice.district })
        if (d_d.length > 0) {
            setMaster(actDevice.sn)
            const d_u = state.systemuser.list.filter(x => { return x.id === d_d[0].user })
            if (d_u.length > 0) {
                p = d_u[0].id
            }
        }
        if(Mode==='soc'){
            form.setFieldsValue({ ...actDevice, num: 1, humi: true, status: false, expire: moment(actDevice.expire, 'YYYY-MM-DD 00:00:00'), time: moment(actDevice.time, 'YYYY-MM-DD 00:00:00'), parent: p,
            iccid_expire: moment(actDevice.iccid_expire, 'YYYY-MM-DD'),
            temp_alarm_high:50,temp_alarm_low:-50,humi_alarm_high:100,humi_alarm_low:0,power_alarm:true,cardedittime:moment(actDevice.cardedittime, 'YYYY-MM-DD'),
            })
        }else{
            form.setFieldsValue({ ...actDevice, num: 1, humi: true, status: false, expire: moment(actDevice.expire, 'YYYY-MM-DD 00:00:00'), time: moment(actDevice.time, 'YYYY-MM-DD 00:00:00'), parent: p,
                temp_alarm_high:50,temp_alarm_low:-50,humi_alarm_high:100,humi_alarm_low:0,power_alarm:true
            })
        }
        var list = [];
        state.systemuser.list.filter(x=>x.parent===state.main.id).map(m=>list.push(m.id+""));
        setDefExpend(list);

        fetch(' http://www.hebeijiuchen.com/sim/user/login.do?username=17734552912&password=123456', { //物联网卡登录 接口请求地址
            method: 'get',
        })
        .then((resp) => {
            resp.json().then(res=>{
                setSimToken(res.token)
            })
        }).catch((error) => {
            console.log(error);
        });
        //  http.get("/v1/devicesiminfo?numbers=89860844152570022900", {}).then(data => {
        //     console.log('data',data);
            
        //  })

}, [])

    return (
        <Form
            form={form}
            {...formItemLayout}
            ref={formRef}
            onFinish={onfinish}
        >

            {
                Mode === 'soc' &&isShowUser && (<Form.Item
                    label="所属用户"
                    name="parent"
                    rules={[
                        {
                            required: true,
                            message: '选择上级用户'
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                const u = state.systemuser.list.filter(x => { return x.id === value || x.id == value.id })
                                if (u.length > 0 && u[0].type !== 104) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('普通用户不可选'));
                            },
                        }),
                    ]}>
                    <TreeSelect
                        // treeDefaultExpandAll
                        showSearch
                        treeNodeFilterProp='name'
                        treeDefaultExpandedKeys={defExpend}
                        treeData={state.systemuser.treeM}
                        placeholder="上级用户"
                        onChange={value => {
                            const u = state.systemuser.list.filter(x => { return x.id === value*1 })
                            if (u.length > 0 && u[0].type !== 104) {
                                // setSelectUser(u[0]);
                                let arrDis = new Array();
                                state.district.filter(x => { return x.user === value }).map(item => arrDis.push(item));
                                setDisOptions(arrDis);
                            }
                        }}
                    />
                </Form.Item>)
            }
            {
                (isShowUser||Mode !== 'soc') &&
                <Form.Item
                label="所属区域"
                name="district"
                rules={[{ required: true, message: '选择所属区域' }]}>
                <Select
                    placeholder="选择区域"
                >
                    {
                        disOptions.map(item => (
                            <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                        ))
                    }
                </Select>
            </Form.Item>
            }
            <div style={{ display: 'flex' }}>
                <Form.Item style={{ width: 300 }}
                    label="主机类型"
                    labelCol={{ span: 8 }}
                    name="type"
                    rules={[{ required: true, message: '选择主机类型' }]}>
                    <Select style={{ width: 150 }}
                        placeholder="主机类型"
                        onChange={value => {
                            if (value === 215){
                                setNodeNum(4)
                                setLockNodeNum(true)
                                console.log('*****');
                                
                            }
                            switch (value) {
                                case 201: formRef.current.setFieldsValue({
                                    location: 2, humi: true,power_alarm:true
                                }); return;
                                case 202: formRef.current.setFieldsValue({
                                    location: 1, humi: false,power_alarm:false
                                }); return;
                                case 203: formRef.current.setFieldsValue({
                                    location: 0, humi: false,power_alarm:false
                                }); return;
                                case 204: formRef.current.setFieldsValue({
                                    location: 2, humi: true,power_alarm:false
                                }); return;
                                case 205: formRef.current.setFieldsValue({
                                    location: 2, humi: false,power_alarm:false
                                }); return;
                                case 207: formRef.current.setFieldsValue({
                                    location: 2, humi: true,power_alarm:true
                                }); return;
                                case 208: formRef.current.setFieldsValue({
                                    location: 2, humi: true,power_alarm:true
                                }); return;
                                case 209: formRef.current.setFieldsValue({
                                    location: 1, humi: false,power_alarm:false
                                }); return;
                                case 213: formRef.current.setFieldsValue({
                                    location: 2, humi: false,power_alarm:false
                                }); 
                                case 215: formRef.current.setFieldsValue({
                                    location: 2, humi: true,power_alarm:false,num:4,
                                }); 
                                return;
                            }
                            
                        }}
                    >
                    {
                        devTypeOption.map(item => (
                            // item.code!==204&&
                            <Select.Option key={item.code} value={item.code}>{item.value}</Select.Option>
                        ))
                    }
                    </Select>
                </Form.Item>
                <Form.Item style={{ width: 300 }}
                    labelCol={{ span: 8 }}
                    label="主机编号"
                    name="sn"
                    onChange={e => {
                        const s = state.device.filter(x => { return x.sn === Number(e.target.value)&&x.node!==0 })
                        if (s.length > 0) {
                            setMaster(s.length);
                            setLockMName(true);
                            formRef.current.setFieldsValue({
                                m_name: s[0].m_name,
                                sim: s[0].sim,
                                node:s.length+1,
                                name:"测点"+(s.length+1),
                                expire: moment(s[0].expire, 'YYYY-MM-DD 00:00:00'),
                                iccid_expire: moment(s[0]?.iccid_expire, 'YYYY-MM-DD 00:00:00'),
                                cardedittime:  moment(s[0]?.cardedittime, 'YYYY-MM-DD 00:00:00'),
                            })
                        } else {
                            setLockMName(false)
                            state.main.type>100?
                            formRef.current.setFieldsValue({
                                m_name: '',
                                sim: '',
                                node:1,
                                name:'测点',
                                expire: moment(actDevice?.expire, 'YYYY-MM-DD 00:00:00'),
                                iccid_expire: moment(actDevice?.iccid_expire, 'YYYY-MM-DD 00:00:00'),
                                cardedittime:  moment(actDevice?.cardedittime, 'YYYY-MM-DD 00:00:00'),
                            })
                            :
                            formRef.current.setFieldsValue({
                                node:1,
                            })
                        }
                    }}
                    rules={[{ required: true, message: '输入主机编号' }]}>
                    <Input disabled={changeDev} />
                </Form.Item>
            </div>

            {
                Mode === "local" ?
                    <div style={{ display: 'flex' }}>
                        <Form.Item style={{ width: 400 }}
                            labelCol={{ span: 6 }}
                            label="主机名称"
                            name="m_name"
                            rules={[{ required: true, message: '输入主机名称' }]}>
                            <Input disabled={lockMName || changeDev} />
                        </Form.Item>
                        <Form.Item style={{ width: 200 }}
                            labelCol={{ span: 12 }}
                            label="平台设备"
                            name="status"
                            valuePropName="checked"
                        >
                            <Checkbox>选择</Checkbox>
                        </Form.Item>
                    </div> :
                    <Form.Item
                        label="主机名称"
                        name="m_name"
                        rules={[{ required: true, message: '输入主机名称' }]}>
                        <Input disabled={lockMName || changeDev} />
                    </Form.Item>
            }
            <div style={{ display: 'flex' }}>
                <Form.Item style={{ width: 340 }}
                    labelCol={{ span: 7 }}
                    label="测点名称"
                    name="name"
                    rules={[{ required: true, message: '输入测点名称' }]}>
                    <Input disabled={nodeNum > 1} />
                </Form.Item>
                <Form.Item style={{ width: 120,}}
                    labelCol={{ span: 10 }}
                    label="断电"
                    name="power_alarm"
                    valuePropName="checked"
                >
                    <Checkbox 
                    // onChange={e=>{
                    //     if(e.target.checked){
                    //         form.setFieldsValue({node:0,num:1});
                    //         setNodeNum(1);
                    //         setNodeStatus1(true);
                    //     }else{
                    //         setNodeStatus1(false);
                    //         !nodeStatus2&&form.setFieldsValue({node:1});
                    //     }
                    // }}
                    >
                        开启
                    </Checkbox>
                </Form.Item>
                <Form.Item style={{ width: 140, }}
                    labelCol={{ span: 12 }}
                    label="开关门"
                    name="door_alarm"
                    valuePropName="checked"
                >
                    <Checkbox>
                        开启
                    </Checkbox>
                </Form.Item>
            </div>
            <div style={{ display: 'flex'}}>
                <Form.Item style={{ width: 300 }}
                    labelCol={{ span: 8 }}
                    // wrapperCol={{ span: 16 }}
                    label="测点ID"
                    name="node"
                    rules={[{ required: true, message: '输入测点ID' }]}>
                    <Input disabled={nodeNum > 1 } onChange={e=>
                        e.target.value!==''&&e.target.value*1===0&&form.setFieldsValue({power_alarm:true})
                    }/>
                </Form.Item>
                <Form.Item style={{ width: 300 }}
                    labelCol={{ span: 11 }}
                    wrapperCol={{ span: 13 }}
                    label="测点数量"
                    name="num"
                    rules={[{ required: true, message: '输入测点数量' }]}>
                    <InputNumber min={1} max={99}  disabled={lockNodeNum} onChange={value => {
                        setNodeNum(value)
                    }} />
                </Form.Item>
                <Form.Item
                    labelCol={{ span: 20 }}
                    wrapperCol={{ span: 13 }}
                    label="已添加测点"
                    name="s">
                    {
                        master
                    }
                </Form.Item>
            </div>
            <div style={{ display: 'flex' }}>
                <Form.Item style={{ width: 300 }}
                    labelCol={{ span: 8 }}
                    label="定位方式"
                    name="location"
                    rules={[{ required: true, message: '选择定位方式' }]}>
                    <Select
                        placeholder="定位方式"
                    >
                        {
                            [{ id: 0, name: '卫星定位' }, { id: 1, name: 'LBS定位' }, { id: 2, name: '无定位' },{id:3,name:'LBS定位2'}].map(item => (
                                <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                            ))
                        }
                    </Select>
                </Form.Item>
                {
                    Mode === "soc"&&state.main.type<103&&
                    <div style={{width:230}}>
                        <Form.Item 
                            labelCol={{ span: 10}}
                            label="卡到期时间"
                            name="iccid_expire"
                        >
                            <DatePicker format={"YYYY-MM-DD"} style={{width:130}}  disabled={lockMName || changeDev}/>
                        </Form.Item>
                    </div>
                    
                }
            </div>
            {/* sim卡号和编辑时间 */}
            <div style={{display: 'flex'}}>
                <Form.Item style={{ width: 300 }}
                    labelCol={{ span: 8 }}
                    label="SIM卡号"
                    name="sim"
                    rules={[{ required: true, message: '输入SIM卡号' }]}>
                    <Input controls={false} disabled={lockMName || changeDev}  style={{width:140}} onChange=
                    {async e=>
                        {
                            form.setFieldsValue({
                                iccid_expire_real:moment('2000-01-01', 'YYYY-MM-DD'),
                                cardedittime:moment(new Date(), 'YYYY-MM-DD'),
                                iccid:''
                            })
                            let val = e.target.value;
                            if(val.length===13){
                                let r = await getSimBySim(val,simToken);
                                setTimeout(() => {
                                    setSimStatus(r.status);
                                    form.setFieldsValue({
                                        iccid_expire_real:moment(r.iccid_expire, 'YYYY-MM-DD'),
                                        iccid1:r.iccid,
                                        cardedittime:moment(new Date(), 'YYYY-MM-DD'),
                                    })
                                }, 1000);
                                
                            }else if(val.length===20){
                                // setSimStatus('卡号错误');
                                let r = await getSimByIccid(val,simToken);
                                    setTimeout(() => {
                                        setSimStatus(r.status);
                                        if(r.state===1){
                                            setSimStatus("停机")
                                        }else if(r.state===2){
                                            setSimStatus("销号")
                                        }
                                        form.setFieldsValue({
                                            iccid_expire_real:moment(r.iccid_expire, 'YYYY-MM-DD'),
                                            iccid1:r.sim,
                                            cardedittime:moment(new Date(), 'YYYY-MM-DD'),
                                        })
                                    }, 1000);
                            }
                            
                            else{
                                // setSimStatus('卡号错误');
                                
                            }
                        }
                    }/>
                </Form.Item>
                {
                    Mode==='soc'&&
                    <Form.Item  
                        labelCol={{ span: 8 }}
                        label="编辑日期"
                        name="cardedittime"
                    >
                        <DatePicker format={"YYYY-MM-DD"} style={{width:130}} disabled />
                    </Form.Item>
                }
                {
                    Mode === "soc"&&state.main.type<101&&
                    <div style={{color:'red'}}>
                        {
                            simStatus
                        }
                    </div>
                }
            </div>
            {/* 卡iccid和到期时间 */}
            <div style={{ display:  Mode==='soc'?'flex':'none'}}>
                <div style={{width:260}}>
                    <Form.Item 
                        labelCol={{ span: 6 }}
                        label="SIMid"
                        name="iccid1"
                    >
                        <Input controls={false} disabled={true}  style={{width:185}} />
                    </Form.Item>
                </div>
                {
                    Mode === "soc"&&state.main.type<101&&
                    <div style={{width:230}}>
                        <Form.Item 
                            labelCol={{ span: 10}}
                            label="到期时间"
                            name="iccid_expire_real"
                        >
                            <DatePicker format={"YYYY-MM-DD"} style={{width:130} } disabled/>
                        </Form.Item>
                    </div>
                    
                }
            </div>
            
            <div style={{ display: 'none' ,marginLeft:10}}>
                <Form.Item style={{width:150}}
                    labelCol={{ span: 14}}
                    label="温度上限"
                    name="temp_alarm_high"
                    rules={[{ required: true, message: '输入温度上限' }]}>
                    <input  style={{ width: 50 }}/>
                </Form.Item>
                <Form.Item style={{width:150}}
                    labelCol={{ span: 14 }}
                    label="温度下限"
                    name="temp_alarm_low"
                    rules={[{ required: true, message: '输入温度下限' }]}>
                    <Input  style={{ width: 50 }}/>
                </Form.Item>
                <Form.Item style={{width:150}}
                    labelCol={{ span: 14 }}
                    label="湿度上限"
                    name="humi_alarm_high"
                    rules={[{ required: true, message: '输入湿度上限' }]}>
                    <input  style={{ width: 50 }}/>
                </Form.Item>
                <Form.Item style={{width:150}}
                    labelCol={{ span: 14 }}
                    label="湿度下限"
                    name="humi_alarm_low"
                    rules={[{ required: true, message: '输入湿度下限' }]}>
                    <Input  style={{ width: 50 }}/>
                </Form.Item>
            </div>
            <div style={{ display: 'flex' }}>
                <Form.Item style={{width:300}}
                    labelCol={{ span: 8 }}
                    label="测点隐藏"
                    name="hide"
                    valuePropName="checked"
                >
                    <Checkbox style={{ width: 80 }}>隐藏</Checkbox>
                </Form.Item>
                {
                    state.main.type < 103 &&
                    <Form.Item style={{ width: 300 }}
                        labelCol={{ span: 8 }}
                        label="安装时间"
                        name="time"
                        rules={[{ required: true, message: '选择安装时间' }]}>
                        <DatePicker format={"YYYY-MM-DD 00:00:00"}  disabledDate={current=>current&&current > moment().endOf('day')}/>
                    </Form.Item>
                }
            </div>
            <div style={{ display: 'flex' }}>
                <Form.Item style={{ width: 300 }}
                    labelCol={{ span: 8 }}
                    label="湿度数据"
                    name="humi"
                    valuePropName="checked"
                >
                    <Checkbox >开启</Checkbox>
                </Form.Item>

                {
                    state.main.type <103 &&Mode==='soc'&&
                    <Form.Item style={{ width: 300 }}
                        labelCol={{ span: 8 }}
                        label="到期时间"
                        name="expire"
                        rules={[{ required: true, message: '选择到期时间' }]}>
                        <DatePicker format={"YYYY-MM-DD 00:00:00"} disabled={state.main.type>101||lockMName}/>
                    </Form.Item>
                }
            </div>

        </Form>
    )
}

export default DeviceNew;